import { createFileRoute } from '@tanstack/react-router';
import { runQuery } from '@/features/runs/api';
import { RunPage } from '@/features/runs/pages/RunPage';
import { runsSearchSchema } from '@/features/runs/search';
import { sourcesQuery } from '@/features/sources/api';

// Carries the history's view, for the way back.
export const Route = createFileRoute('/_authed/ops/runs/$runId')({
  staticData: { help: 'run' },
  validateSearch: runsSearchSchema,
  loader: ({ context: { queryClient }, params }) => {
    void queryClient.prefetchQuery(runQuery(params.runId));
    void queryClient.prefetchQuery(sourcesQuery());
  },
  component: RunPage,
});
